import React, { useState, useEffect } from "react";
import { FaTruck } from "react-icons/fa";
import { FaWarehouse } from "react-icons/fa6";
import { GiHut } from "react-icons/gi";
import { MdDirectionsBike } from "react-icons/md";
import { BsBagCheckFill } from "react-icons/bs";
import { BsFillBagXFill } from "react-icons/bs";
import { MdTimelapse } from "react-icons/md";
import Dropdown from "react-bootstrap/Dropdown";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
  Modal,
  Box,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Link, useNavigate } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import { toast } from "react-toastify";

const columns = [
  { id: "city", label: "CITY", minWidth: 100, align: "center" },
  {
    id: "total",
    label: "TOTAL ORDERS DELIVERED",
    minWidth: 170,
    align: "center",
  },
];

function createData(city, total) {
  return { city, total };
}

const rows = [
  createData("Hyderabad", "200"),
  createData("Vijayawada", "180"),
  createData("Mumbai", "160"),
  createData("Hyderabad", "200"),
  createData("Vijayawada", "180"),
  createData("Mumbai", "160"),
];

export const Dashboard = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const navigate = useNavigate();

  const [dashboardList, setDashboardList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("All");

  const fetchDashboard = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get("/admin/dashboard/");
      if (res.data.status === "success") {
        const data = res.data.data || {};

        // Convert total_orders_by_city to array of { city, total }
        const totalOrdersArray = Object.entries(
          data.total_orders_by_city || {}
        ).map(([city, total]) => ({ city, total }));

        setDashboardList({
          ...data,
          total_orders_by_city: totalOrdersArray,
        });
      } else {
        setError("Failed to fetch Dashboard data.");
      }
    } catch (err) {
      console.error("Error fetching Dashboard data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  console.log(dashboardList);

  return (
    <div className="overContainer">
      <div>
        <div className="dashboardTitle">Overall Stats</div>
        <div className="overallGrid">
          <div
            className="overCard"
            style={{
              backgroundColor: "#5BB5F51A",
              border: "1px solid #E7F0F9",
            }}
          >
            <div className="overCardContent">
              <div>Total Order’s Delivered</div>
              <div>{dashboardList?.overall_stats?.orders_delivered || 0}</div>
            </div>
            <div>
              <FaTruck
                className="overCardIcon"
                style={{ backgroundColor: "#5BB5F5" }}
              />
            </div>
          </div>
          <div
            className="overCard"
            style={{
              backgroundColor: "#E5CF9F1A",
              border: "1px solid #E7F0F9",
            }}
          >
            <div className="overCardContent">
              <div>Total Wholesalers</div>
              <div>{dashboardList?.overall_stats?.wholesalers || 0}</div>
            </div>
            <div>
              <FaWarehouse
                className="overCardIcon"
                style={{ backgroundColor: "#E5CF9F" }}
              />
            </div>
          </div>
        </div>
        <div className="overallGrid">
          <div
            className="overCard"
            style={{
              backgroundColor: "#C681D81A",
              border: "1px solid #E7F0F9",
            }}
          >
            <div className="overCardContent">
              <div>Total Retailers</div>
              <div>{dashboardList?.overall_stats?.retailers || 0}</div>
            </div>
            <div>
              <GiHut
                className="overCardIcon"
                style={{ backgroundColor: "#C681D8" }}
              />
            </div>
          </div>
          <div
            className="overCard"
            style={{
              backgroundColor: "#DF85851A",
              border: "1px solid #E7F0F9",
            }}
          >
            <div className="overCardContent">
              <div>Total Delivery Ryders</div>
              <div>{dashboardList?.overall_stats?.delievery_riders || 0}</div>
            </div>
            <div>
              <MdDirectionsBike
                className="overCardIcon"
                style={{ backgroundColor: "#DF8585" }}
              />
            </div>
          </div>
        </div>
      </div>
      {/* delivery stats  */}
      <div className="deliveryContainer">
        <div className="dashboardTitle">Delivery Stats</div>
        <div className="deliveryGrid">
          <div
            className="overCard"
            style={{ backgroundColor: "#FCFCFC", border: "1px solid #E7F0F9" }}
          >
            <div className="overCardContent">
              <div>Completed</div>
              <div>{dashboardList?.daily_stats?.completed || 0}</div>
            </div>
            <div>
              <BsBagCheckFill
                className="overCardIcon"
                style={{ backgroundColor: "#6AD581" }}
              />
            </div>
          </div>
          <div
            className="overCard"
            style={{ backgroundColor: "#FCFCFC", border: "1px solid #E7F0F9" }}
          >
            <div className="overCardContent">
              <div>In Progress</div>
              <div>{dashboardList?.daily_stats?.in_progress || 0}</div>
            </div>
            <div>
              <MdTimelapse
                className="overCardIcon"
                style={{ backgroundColor: "#EAAE2D" }}
              />
            </div>
          </div>
          <div
            className="overCard"
            style={{ backgroundColor: "#FCFCFC", border: "1px solid #E7F0F9" }}
          >
            <div className="overCardContent">
              <div>Cancelled</div>
              <div>{dashboardList?.daily_stats?.cancelled || 0}</div>
            </div>
            <div>
              <BsFillBagXFill
                className="overCardIcon"
                style={{ backgroundColor: "#F6633E" }}
              />
            </div>
          </div>
        </div>
      </div>
      {/* total orders  */}
      <div className="totalContainer">
        <div className="totalFilterContainer">
          <div className="dashboardTitle">Total Orders by City</div>
          {/* <div>
            <Dropdown>
              <Dropdown.Toggle
                id="dropdown-basic"
                className="totalFilterToggle"
              >
                {selectedFilter === "All" ? "Filter" : selectedFilter}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {["Today", "Yesterday", "Last 7 days", "Last 15 days"].map(
                  (label) => (
                    <Dropdown.Item
                      key={label}
                      onClick={() => setSelectedFilter(label)}
                    >
                      {label}
                    </Dropdown.Item>
                  )
                )}
                <Dropdown.Item>
                  <input
                    type="date"
                    className="form-control"
                    onChange={(e) => setSelectedFilter(e.target.value)}
                  />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div> */}
        </div>

        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      className="table-header"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : dashboardList.total_orders_by_city?.length > 0 ? (
                  dashboardList.total_orders_by_city
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        className="table-row"
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                        sx={{
                          backgroundColor:
                            index % 2 === 1 ? "#E7F0F9" : "white",
                        }}
                      >
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={columns.length}
                      align="center"
                      style={{ padding: "40px 0" }}
                    >
                      No Data Available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[20, 50, 100, 500, 1000, 2000, 5000]}
            component="div"
            count={dashboardList.total_orders_by_city?.length || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    </div>
  );
};
